import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';
import { ToastType } from 'src/app/enum/toast.enum';
import { Toast } from 'src/app/models/toast.model';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ToastComponent {
  public toasts$: Observable<Toast[]>;
  public ToastType = ToastType;

  constructor(private toastService: ToastService) {
    this.toasts$ = this.toastService.toasts$;
  }

  public dismiss(id: number): void {
    this.toastService.dismiss(id);
  }
}
